import { useState } from 'react'
import { Star, MessageSquare, CheckCircle2, Clock } from 'lucide-react'

const FEEDBACK = [
  { id: 'FB-001', user: 'Sarah Mitchell', rating: 5, msg: 'Excellent dashboard! Very intuitive and fast.', category: 'UI/UX', date: 'May 3, 2025', status: 'reviewed' },
  { id: 'FB-002', user: 'James Holloway', rating: 4, msg: 'Great features, would love more chart options.', category: 'Feature', date: 'May 2, 2025', status: 'pending' },
  { id: 'FB-003', user: 'Priya Sharma', rating: 5, msg: 'The dark mode is beautiful. Best admin panel I\'ve used.', category: 'UI/UX', date: 'May 1, 2025', status: 'reviewed' },
  { id: 'FB-004', user: 'Luca Martini', rating: 3, msg: 'Had some issues with the API export, needs fixing.', category: 'Bug', date: 'Apr 30, 2025', status: 'in-progress' },
  { id: 'FB-005', user: 'Emily Chen', rating: 4, msg: 'Very clean layout. The analytics section is top-tier.', category: 'Feature', date: 'Apr 28, 2025', status: 'reviewed' },
]
const STATUS = { reviewed: { cls: 'badge-active', l: 'Reviewed' }, pending: { cls: 'badge-pending', l: 'Pending' }, 'in-progress': { cls: 'badge-warning', l: 'In Progress' } }
const AVG_RATING = (FEEDBACK.reduce((s, f) => s + f.rating, 0) / FEEDBACK.length).toFixed(1)

export default function Feedback() {
  const [filter, setFilter] = useState('all')
  const visible = filter === 'all' ? FEEDBACK : FEEDBACK.filter(f => f.category === filter)

  return (
    <div className="dash-page page-in">
      <h1 className="page-title">Feedback</h1>

      <div className="stats-grid cols-4">
        {[
          { label: 'Total Feedback', value: FEEDBACK.length, color: '#4F46E5', colorGlow: 'rgba(79,70,229,0.18)', icon: '💬',trendColor: '#4F46E5', trend: '+12%' , variant: 'indigo' },
          { label: 'Avg Rating', value: `${AVG_RATING} ★`, color: '#F59E0B', colorGlow: 'rgba(245,158,11,0.15)', icon: '⭐', trend: '10%',trendColor: '#F59E0B', variant: 'amber' },
          { label: 'Reviewed', value: FEEDBACK.filter(f => f.status === 'reviewed').length, color: '#10B981', colorGlow: 'rgba(16,185,129,0.15)', icon: '✓', trend: '+5%',trendColor: '#10B981', variant: 'green' },
          { label: 'Pending Review', value: FEEDBACK.filter(f => f.status === 'pending').length, color: '#EF4444', colorGlow: 'rgba(239,68,68,0.15)', icon: '!', trend: '0%', trendDir: 'neutral', trendColor: '#EF4444', variant: 'red' },
        ].map(s => (
          <div key={s.label} className={`stat-card stat-card--${s.variant}`}>
            <span style={{"position": "absolute", "top": "0px", "right": "0px", "width": "110px", "height": "110px", "border-radius": "50%", "background": s.colorGlow  , "filter": "blur(30px)", "transform": "translate(30%, -30%)", "pointer-events": "none"}}></span>
            <div className="stat-card-header">
              <div className="stat-card-icon" style={{ background: s.colorGlow, color: s.color, border: `1px solid ${s.colorGlow}` }}>
                {s.color === '#4F46E5' && <MessageSquare size={18} strokeWidth={1.8} />}
                {s.color === '#F59E0B' && <Star size={18} strokeWidth={1.8} />}
                {s.color === '#10B981' && <CheckCircle2 size={18} strokeWidth={1.8} />}
                {s.color === '#EF4444' && <Clock size={18} strokeWidth={1.8} />}
              </div>
              <span className={`stat-card-trend${s.trendDir === 'neutral' ? ' neutral' : ''}`} style={{ color: s.trendColor, background: `${s.trendColor}15`, border: `1px solid ${s.colorGlow}` }}>
                {s.trend}
              </span>
            </div>
            <div className="stat-card-value">{s.value}</div>
            <div className="stat-card-label">{s.label}</div>
            <div style={{ "position": "absolute", "bottom": "0px", "left": "0px", "right": "0px", "height": "2px", background: `linear-gradient(90deg,${s.color}88,transparent)`, "border-radius": "0 0 var(--radius-lg) var(--radius-lg)" }}></div>
          </div>
        ))}
      </div>

      <div className="view-tabs">
        {['all', 'UI/UX', 'Feature', 'Bug'].map(f => (
          <button key={f} className={`vtab${filter === f ? ' active' : ''}`} onClick={() => setFilter(f)}>
            {f}
          </button>
        ))}
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-md)' }}>
        {visible.map(fb => (
          <div key={fb.id} className="card">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 'var(--space-sm)', flexWrap: 'wrap', gap: 'var(--space-sm)' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-sm)' }}>
                <div style={{ width: 36, height: 36, borderRadius: '50%', background: 'var(--bg-active)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 'var(--fs-xs)', fontWeight: 700, color: 'var(--accent-hover)', flexShrink: 0 }}>
                  {fb.user.split(' ').map(n => n[0]).join('')}
                </div>
                <div>
                  <div style={{ fontWeight: 600, color: 'var(--text1)', fontSize: 'var(--fs-sm)' }}>{fb.user}</div>
                  <div style={{ fontSize: 'var(--fs-xs)', color: 'var(--text3)' }}>{fb.date}</div>
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-sm)' }}>
                <div style={{ display: 'flex', gap: 2 }}>
                  {[1, 2, 3, 4, 5].map(s => (
                    <Star key={s} size={13} fill={s <= fb.rating ? '#F59E0B' : 'none'} color={s <= fb.rating ? '#F59E0B' : '#4A5578'} />
                  ))}
                </div>
                <span className="badge badge-gold">{fb.category}</span>
                <span className={`badge ${STATUS[fb.status].cls}`}>{STATUS[fb.status].l}</span>
              </div>
            </div>
            <p style={{ fontSize: 'var(--fs-base)', color: 'var(--text2)', lineHeight: 1.6, paddingLeft: 44 }}>"{fb.msg}"</p>
          </div>
        ))}
      </div>
      <style>{`.dash-page{display:flex;flex-direction:column;gap:var(--space-lg);width:100%;}`}</style>
    </div>
  )
}
